import formLogin from './form_login.js';
import formForgot from './form_forgot.js';
// import captcha from './../tools/captcha.js';

const sectionLoginFormMain = document.querySelector('#sectionLoginFormMain');

const inputFields = {
  'loginLogin': sectionLoginFormMain.querySelector('#loginInputLogin'),
  'loginPassword': sectionLoginFormMain.querySelector('#loginInputPassword'),
  'forgotInputEmail': sectionLoginFormMain.querySelector('#forgotInputEmail'),
};

const inputFieldsErrors = {
  'loginLogin': sectionLoginFormMain.querySelector('#loginInputLoginError'),
  'loginPassword': sectionLoginFormMain.querySelector('#loginInputPasswordError'),
  'forgotInputEmail': sectionLoginFormMain.querySelector('#forgotInputEmailError')
};

const progressBar = {
  'loginProgress': sectionLoginFormMain.querySelector('#loginProgress'),
  'forgotProgress': sectionLoginFormMain.querySelector('#forgotProgress')
};

const buttons = {
  'loginButtonSubmit': sectionLoginFormMain.querySelector('#loginButtonSubmit'),
  'forgotButtonSubmit': sectionLoginFormMain.querySelector('#forgotButtonSubmit')
};

let resetErrors = function () {
  let errObj = Object.keys(inputFieldsErrors);
  let inObg = Object.keys(inputFields);

  errObj.forEach(function (value) {
    inputFieldsErrors[value].innerHTML = '';
  });

  inObg.forEach(function (value) {
    inputFields[value].classList.remove('border');
    inputFields[value].classList.remove('border-danger');
  });
};

sectionLoginFormMain.addEventListener('change', function (event) {

  inputFieldsErrors[event.target.dataset.erreset].innerHTML = '';
  event.target.classList.remove('border');
  event.target.classList.remove('border-danger');
});


document.addEventListener('logoutSuccess', function () {
  formInit();
});

let formInit = function () {

  resetErrors();

  formForgot.reset();
  formLogin.reset();
  formForgot.hide();
  formLogin.show();

};

export default {

  init: formInit,

  confirmEmail() {
  },

  register() {
  },

  forgot() {
    formLogin.hide();
    formForgot.show();
  },

  setError(target, msg) {
    inputFieldsErrors[target].innerHTML = msg;
    inputFields[target].classList.add('border');
    inputFields[target].classList.add('border-danger');
  },

  showProgress(button, progress) {
    progressBar[progress].classList.remove('invisible');
    if (button) {
      buttons[button].disabled = true;
    }
  },

  hideProgress(button, progress) {
    progressBar[progress].classList.add('invisible');
    buttons[button].disabled = false;
  }
};
